import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import "../../../StyleSheet/MainComponent/Sheetupoad.scss";
import $ from "jquery";
import {
  setTheSHeetuploaAction,
  GetSheetBulkUploadDataRequest,
} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import { FaDownload } from "react-icons/fa";
import SheetUploadPopup from "./SheetUploadPopup";
import * as XLSX from "xlsx";
import Spreadsheet from "react-spreadsheet";
import { saveAs } from "file-saver";
import axios from "axios";
import {
  ClientBulkUploadSampleSheetApi,
  organization_listapi,
} from "../../../text/apidata";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const SheetUpload = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const userSessionData = useSelector((state) => state?.users?.UserData);
  // Client upload: the sample sheet columns depend on the organisation
  const [organizationOptions, setOrganizationOptions] = useState([]);
  const [organization, setOrganization] = useState(null);
  const [organizationErr, setOrganizationErr] = useState("");
  const [sampleLoading, setSampleLoading] = useState(false);
  const formdatas = new FormData();
  const [apidata, setApidata] = useState(null);
  const [key, setKey] = useState(null);
  const [ErrorKey, setErroKey] = useState(0);

  const dispatch = useDispatch();

  // New screen: history table + "Bulk Upload" popup (only Designation and Client)
  const [sno, setsno] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [dtpageindex, setdtPageindex] = useState(1);
  const [uploadPopup, setUploadPopup] = useState(false);
  // history filter: All (Client + Designation) by default; "0" Client, "7" Designation
  const reportTypeOptions = [
    { value: "", label: "All" },
    { value: "0", label: "Client" },
    { value: "7", label: "Designation" },
  ];
  const [reportTypeFilter, setReportTypeFilter] = useState(reportTypeOptions[0]);
  const historyPayload = (page) => ({
    page_size: 20,
    page,
    search: "",
    ...(reportTypeFilter.value ? { report_type: reportTypeFilter.value } : {}),
  });
  const { sheetBulkUploaddata, totalCount } = useSelector(
    (state) => state.sheetBulkUploadGetData
  );

  useEffect(() => {
    dispatch(
      GetSheetBulkUploadDataRequest(historyPayload(dtpageindex))
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dtpageindex, reportTypeFilter]);

  // Keep refreshing while any upload is still processing
  useEffect(() => {
    if (!sheetBulkUploaddata?.some((item) => item.status === "0")) return;
    const interval = setInterval(() => {
      dispatch(
        GetSheetBulkUploadDataRequest(historyPayload(dtpageindex))
      );
    }, 5000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sheetBulkUploaddata]);

  const downloadFile = (url) => {
    if (!url) return;
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadIcon = (url, title) =>
    url ? (
      <span style={{ cursor: "pointer" }} onClick={() => downloadFile(url)} title={title}>
        <FaDownload size={18} />
      </span>
    ) : (
      "-"
    );

  const historyColumns = useMemo(
    () => [
      {
        Header: "S.NO",
        accessor: "",
        Cell: (row) => <p>{Number(sno + row.row.index + 1)}</p>,
      },
      {
        Header: "Created Date",
        accessor: "",
        Cell: (row) => {
          const created = row.row.original.created_at;
          const d = new Date(created);
          const h = d.getHours();
          const m = d.getMinutes();
          return (
            <span>{`${created.slice(0, 10)}  ${h % 12 || 12}:${m < 10 ? `0${m}` : m} ${h >= 12 ? "PM" : "AM"}`}</span>
          );
        },
      },
      {
        Header: "File Name",
        accessor: "file_name",
        Cell: (row) => (
          // <span style={{ width: "160px", display: "inline-block", wordBreak: "break-word" }}>
          <span>
            {row.row.original?.file_name}
          </span>
        ),
      },
      { Header: "Total Count", accessor: "total_count" },
      { Header: "Sucess Count", accessor: "valid_count" },
      { Header: "Defect Count", accessor: "defect_count" },
      {
        Header: "Uploaded Sheet",
        accessor: "",
        Cell: (row) => downloadIcon(row.row.original?.uploaded_sheet, "Download Uploaded Sheet"),
      },
      {
        Header: "Defect Sheet",
        accessor: "defect_sheet",
        Cell: (row) => downloadIcon(row.row.original?.defect_sheet, "Download Defect Sheet"),
      },
      {
        Header: "Process",
        accessor: "upload_status",
        Cell: (row) => <span>{Math.round(Number(row.row.original?.upload_status || 0))}%</span>,
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: (row) => {
          const s = row.row.original?.status;
          return <span>{s == "0" ? "Pending" : s == "1" ? "Completed" : "Failed"}</span>;
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [sheetBulkUploaddata, sno]
  );

// Old upload options (State, Role, Perform, Perform Type, Side bar, Grievance type, Leave type)
// and the old form screen are kept commented below, only Designation and Client are shown now.
//   const options = [
//     // {
//     //   label: "Client Branch",
//     //   value: "client_branch",
//     // },
//     {
//       label: "Client ",
//       value: "client_parent",
//     },
//     {
//       label: "State",
//       value: "state",
//     },
//     {
//       label: "Role",
//       value: "role",
//     },
//     {
//       label: "Perform",
//       value: "perform_type",
//     },
//     {
//       label: "Perform Type",
//       value: "perform_question",
//     },
//     {
//       label: "Side bar",
//       value: "side_bar",
//     },
//     {
//       label: "Grievance type",
//       value: "grievance_type",
//     },
//     {
//       label: "Leave type",
//       value: "leave_type",
//     },
//   ];

  const [FileType, setFileType] = useState("");
  const [fileErr, setFileErr] = useState("");
  const [file, setFile] = useState();
  const [fileemp, setFileEp] = useState("");

  const [data, setData] = useState([]);

  const handleSelectChange = (val) => {
    setFileType(val.value);
  };

  // Organisations are needed only for the Client sample sheet - load them when Client is chosen
  useEffect(() => {
    if (FileType !== "client_parent" || organizationOptions.length > 0) return;
    axios({
      method: "get",
      url: organization_listapi,
      headers: { Authorization: "Bearer " + userSessionData?.session?.token },
    })
      .then((response) => {
        const list = Array.isArray(response?.data?.data) ? response.data.data : [];
        setOrganizationOptions(
          list.map((org) => ({ value: org.id, label: org.organization_name }))
        );
      })
      .catch(() => toast.error("Failed to load organisations"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [FileType]);
  var z = 0;
  
  $("form").on("change", ".file-upload-field", function () {
    $(this)
      .parent(".file-upload-wrapper")
      .attr(
        "data-text",
        $(this)
          .val()
          .replace(/.*(\/|\\)/, "")
      );
  });
  const HandleChanegsFile = (e) => {
    if (FileType == "") {
      z = 1;
      setFileErr("*file name is required");
    }

    setFile(e.target.files[0]);
    const file = e.target.files[0];

    const reader = new FileReader();

    reader.onload = (e) => {
      const binaryStr = e.target.result;
      const workbook = XLSX.read(binaryStr, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const parsedData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
      setData(parsedData);
    };

    reader.readAsBinaryString(file);

    //  console.log(e.target.files[0] ,"sdfcwuca");
  };

  // Initial data
  const [datas, setDatas] = useState([
    [
      { value: "A1" },
      { value: "B1" },
      { value: "C1" },
      { value: "D1" },
      { value: "E1" },
      { value: "F1" },
      { value: "G1" },
      { value: "H1" },
    ],
    [
      { value: "A2" },
      { value: "B2" },
      { value: "C2" },
      { value: "D2" },
      { value: "E2" },
      { value: "F2" },
      { value: "G2" },
      { value: "H2" },
    ],
    [
      { value: "A3" },
      { value: "B3" },
      { value: "C3" },
      { value: "D3" },
      { value: "E3" },
      { value: "F3" },
      { value: "G3" },
      { value: "H3" },
    ],
    [
      { value: "A4" },
      { value: "B4" },
      { value: "C4" },
      { value: "D4" },
      { value: "E4" },
      { value: "F4" },
      { value: "G4" },
      { value: "H4" },
    ],
    [
      { value: "A5" },
      { value: "B5" },
      { value: "C5" },
      { value: "D5" },
      { value: "E5" },
      { value: "F5" },
      { value: "G5" },
      { value: "H5" },
    ],
    [
      { value: "A6" },
      { value: "B6" },
      { value: "C6" },
      { value: "D6" },
      { value: "E6" },
      { value: "F6" },
      { value: "G6" },
      { value: "H6" },
    ],
  ]);

  useEffect(() => {
    if (FileType == "side_bar") {
      setDatas([
        [
          { value: "display_name" },
          { value: "unique_name" },
          { value: "display_order" },
          // { value: "D1" },
          // { value: "E1" },
          // { value: "F1" },
          // { value: "G1" },
          // { value: "H1" },
        ],
        [
          { value: "CLIENT" },
          { value: "client" },
          { value: "1" },
          // { value: "D2" },
          // { value: "E2" },
          // { value: "F2" },
          // { value: "G2" },
          // { value: "H2" },
        ],
        [
          { value: "ROLE" },
          { value: "role" },
          { value: "2" },
          // { value: "D3" },
          // { value: "E3" },
          // { value: "F3" },
          // { value: "G3" },
          // { value: "H3" },
        ],
        [
          { value: "KYC VERIFICATION" },
          { value: "kyc verification" },
          { value: "3" },
          // { value: "D4" },
          // { value: "E4" },
          // { value: "F4" },
          // { value: "G4" },
          // { value: "H4" },
        ],
        [
          { value: "ATTENDANCE" },
          { value: "attendances" },
          { value: "4" },
          // { value: "D5" },
          // { value: "E5" },
          // { value: "F5" },
          // { value: "G5" },
          // { value: "H5" },
        ],
        [
          { value: "SKILL ASSEMENTS" },
          { value: "assements" },
          { value: "5" },
          // { value: "D6" },
          // { value: "E6" },
          // { value: "F6" },
          // { value: "G6" },
          // { value: "H6" },
        ],
      ]);
    } else if (FileType == "client_parent") {
      setDatas([
        [
          { value: "CLNT" },
          { value: "PERAREA" },
          { value: "PROJNO" },
          // { value: "DWEB ELEMENT1" },
          // { value: "LOCATION" },
          // { value: "F1" },
          // { value: "G1" },
          // { value: "H1" },
        ],
        [
          { value: "UDS" },
          { value: "0978" },
          { value: "UDS273648723" },
          // { value: "UDS273648723" },
          // { value: "TAMBARAN" },
          // { value: "F2" },
          // { value: "G2" },
          // { value: "H2" },
        ],
        [
          { value: "CODOID" },
          { value: "0978" },
          { value: "UDS273648723" },
          // { value: "UDS273648723" },
          // { value: "TAMBARAN" },
          // { value: "F3" },
          // { value: "G3" },
          // { value: "H3" },
        ],
        [
          { value: "UDS" },
          { value: "0978" },
          { value: "UDS273648723" },
          // { value: "UDS273648723" },
          // { value: "TAMBARAN" },
          // { value: "F4" },
          // { value: "G4" },
          // { value: "H4" },
        ],
        [
          { value: "UDS" },
          { value: "0978" },
          { value: "UDS273648723" },
          // { value: "UDS273648723" },
          // { value: "TAMBARAN" },
          // { value: "F5" },
          // { value: "G5" },
          // { value: "H5" },
        ],
        [
          { value: "UDS" },
          { value: "0978" },
          { value: "UDS273648723" },
          // { value: "UDS273648723" },
          // { value: "TAMBARAN" },
          // { value: "F6" },
          // { value: "G6" },
          // { value: "H6" },
        ],
      ]);
    } else if (FileType == "state") {
      setDatas([
        [
          { value: "Per Area" },
          { value: "State" },
          // { value: "C1" },
          // { value: "D1" },
          // { value: "E1" },
          // { value: "F1" },
          // { value: "G1" },
          // { value: "H1" },
        ],
        [
          { value: "1100" },
          { value: "TAMIL NADU" },
          // { value: "C2" },
          // { value: "D2" },
          // { value: "E2" },
          // { value: "F2" },
          // { value: "G2" },
          // { value: "H2" },
        ],
        [
          { value: "1100" },
          { value: "PUDUCHERRY" },
          // { value: "C3" },
          // { value: "D3" },
          // { value: "E3" },
          // { value: "F3" },
          // { value: "G3" },
          // { value: "H3" },
        ],
        [
          { value: "1100" },
          { value: "KERALA" },
          // { value: "C4" },
          // { value: "D4" },
          // { value: "E4" },
          // { value: "F4" },
          // { value: "G4" },
          // { value: "H4" },
        ],
        [
          { value: "1100" },
          { value: "TELANGANA" },
          // { value: "C5" },
          // { value: "D5" },
          // { value: "E5" },
          // { value: "F5" },
          // { value: "G5" },
          // { value: "H5" },
        ],
        [
          { value: "1100" },
          { value: "KARNATAKA" },
          // { value: "C6" },
          // { value: "D6" },
          // { value: "E6" },
          // { value: "F6" },
          // { value: "G6" },
          // { value: "H6" },
        ],
      ]);
    } else if (FileType == "role") {
      setDatas([
        [
          { value: "Position No" },
          { value: "Designation" },
          // { value: "C1" },
          // { value: "D1" },
          // { value: "E1" },
          // { value: "F1" },
          // { value: "G1" },
          // { value: "H1" },
        ],
        [
          { value: "50544975" },
          { value: "TECHNICAL ASSOCIATE 30" },
          // { value: "C2" },
          // { value: "D2" },
          // { value: "E2" },
          // { value: "F2" },
          // { value: "G2" },
          // { value: "H2" },
        ],
        [
          { value: "50544975" },
          { value: "ASST STATISTICS OFFICER" },
          // { value: "C3" },
          // { value: "D3" },
          // { value: "E3" },
          // { value: "F3" },
          // { value: "G3" },
          // { value: "H3" },
        ],
        [
          { value: "50544975" },
          { value: "TECHNICAL ASSOCIATE 30" },
          // { value: "C4" },
          // { value: "D4" },
          // { value: "E4" },
          // { value: "F4" },
          // { value: "G4" },
          // { value: "H4" },
        ],
        [
          { value: "50544975" },
          { value: "PHARMACIST GRADE  2 O" },
          // { value: "C5" },
          // { value: "D5" },
          // { value: "E5" },
          // { value: "F5" },
          // { value: "G5" },
          // { value: "H5" },
        ],
        [
          { value: "50544975" },
          { value: "TECHNICAL ASSOCIATE 30" },
          // { value: "C6" },
          // { value: "D6" },
          // { value: "E6" },
          // { value: "F6" },
          // { value: "G6" },
          // { value: "H6" },
        ],
      ]);
    } else if (FileType == "leave_type") {
      setDatas([
        [
          { value: "LEAVE_TYPE" },
          { value: "DESCRIPTION" },
          // { value: "C1" },
          // { value: "D1" },
          // { value: "E1" },
          // { value: "F1" },
          // { value: "G1" },
          // { value: "H1" },
        ],
        [
          { value: "PERSONAL_LEAVE" },
          { value: "personal_leave" },
          // { value: "C2" },
          // { value: "D2" },
          // { value: "E2" },
          // { value: "F2" },
          // { value: "G2" },
          // { value: "H2" },
        ],
        [
          { value: "CASUAL_LEAVE" },
          { value: "casual_leave" },
          // { value: "C3" },
          // { value: "D3" },
          // { value: "E3" },
          // { value: "F3" },
          // { value: "G3" },
          // { value: "H3" },
        ],
        [
          { value: "LOSS_OF_PAY" },
          { value: "loss_of_pay" },
          // { value: "C4" },
          // { value: "D4" },
          // { value: "E4" },
          // { value: "F4" },
          // { value: "G4" },
          // { value: "H4" },
        ],
        // [
        //   { value: "A5" },
        //   { value: "B5" },
        //   { value: "C5" },
        //   { value: "D5" },
        //   { value: "E5" },
        //   { value: "F5" },
        //   { value: "G5" },
        //   { value: "H5" },
        // ],
        // [
        //   { value: "A6" },
        //   { value: "B6" },
        //   { value: "C6" },
        //   { value: "D6" },
        //   { value: "E6" },
        //   { value: "F6" },
        //   { value: "G6" },
        //   { value: "H6" },
        // ],
      ]);
    } else if (FileType == "grievance_type") {
      setDatas([
        [
          { value: "GRIEVANCE TYPE" },
          { value: "DESCRIPTION" },
          // { value: "C1" },
          // { value: "D1" },
          // { value: "E1" },
          // { value: "F1" },
          // { value: "G1" },
          // { value: "H1" },
        ],
        [
          { value: "UNIFORM ISSUE" },
          { value: "Uniform Issue" },
          // { value: "C2" },
          // { value: "D2" },
          // { value: "E2" },
          // { value: "F2" },
          // { value: "G2" },
          // { value: "H2" },
        ],
        [
          { value: "SHIFT NOT ALLOCATED" },
          { value: "Shift Not Allocated" },
          // { value: "C3" },
          // { value: "D3" },
          // { value: "E3" },
          // { value: "F3" },
          // { value: "G3" },
          // { value: "H3" },
        ],
        [
          { value: "OTHER" },
          { value: "Other" },
          // { value: "C4" },
          // { value: "D4" },
          // { value: "E4" },
          // { value: "F4" },
          // { value: "G4" },
          // { value: "H4" },
        ],
        // [
        //   { value: "A5" },
        //   { value: "B5" },
        //   { value: "C5" },
        //   { value: "D5" },
        //   { value: "E5" },
        //   { value: "F5" },
        //   { value: "G5" },
        //   { value: "H5" },
        // ],
        // [
        //   { value: "A6" },
        //   { value: "B6" },
        //   { value: "C6" },
        //   { value: "D6" },
        //   { value: "E6" },
        //   { value: "F6" },
        //   { value: "G6" },
        //   { value: "H6" },
        // ],
      ]);
    } else if (FileType == "perform_question") {
      setDatas([
        [
          { value: "manpower_grading_points" },
          { value: "total_points" },
          { value: "points" },
          // { value: "D1" },
          // { value: "E1" },
          // { value: "F1" },
          // { value: "G1" },
          // { value: "H1" },
        ],
        [
          { value: "Grooming Standard" },
          { value: "10" },
          { value: "1" },
          // { value: "D2" },
          // { value: "E2" },
          // { value: "F2" },
          // { value: "G2" },
          // { value: "H2" },
        ],
        [
          { value: "Knowledge of site areas" },
          { value: "5" },
          { value: "0.833" },
          // { value: "D3" },
          // { value: "E3" },
          // { value: "F3" },
          // { value: "G3" },
          // { value: "H3" },
        ],
        [
          { value: "Knowledge of washroom cleaning" },
          { value: "10" },
          { value: "1" },
          // { value: "D4" },
          // { value: "E4" },
          // { value: "F4" },
          // { value: "G4" },
          // { value: "H4" },
        ],
        [
          { value: "Knowledge of chemical usage" },
          { value: "10" },
          { value: "2" },
          // { value: "D5" },
          // { value: "E5" },
          // { value: "F5" },
          // { value: "G5" },
          // { value: "H5" },
        ],
        [
          { value: "Knowledge of HK Equipments" },
          { value: "5" },
          { value: "1" },
          // { value: "D6" },
          // { value: "E6" },
          // { value: "F6" },
          // { value: "G6" },
          // { value: "H6" },
        ],
      ]);
    } else if (FileType == "perform_type") {
      setDatas([
        [
          { value: "Question" },
          { value: "Perform Name" },
          // { value: "D1" },
          // { value: "E1" },
          // { value: "F1" },
          // { value: "G1" },
          // { value: "H1" },
        ],
        [
          { value: "Shaved" },
          { value: "Grooming Standard" },
          // { value: "D2" },
          // { value: "E2" },
          // { value: "F2" },
          // { value: "G2" },
          // { value: "H2" },
        ],
        [
          { value: "Shoes Polished" },
          { value: "Grooming Standard" },
          // { value: "D3" },
          // { value: "E3" },
          // { value: "F3" },
          // { value: "G3" },
          // { value: "H3" },
        ],
        [
          { value: "Wearing Complete Uniform" },
          { value: "Grooming Standard" },
          // { value: "D4" },
          // { value: "E4" },
          // { value: "F4" },
          // { value: "G4" },
          // { value: "H4" },
        ],
        [
          { value: "Uniform Cleaned" },
          { value: "Grooming Standard" },
          // { value: "D5" },
          // { value: "E5" },
          // { value: "F5" },
          // { value: "G5" },
          // { value: "H5" },
        ],
        [
          { value: "Hair Combed" },
          { value: "Grooming Standard" },
          // { value: "D6" },
          // { value: "E6" },
          // { value: "F6" },
          // { value: "G6" },
          // { value: "H6" },
        ],
      ]);
    }

    // else if (FileType == "client_branch") {
    //   setDatas([
    //     [
    //       { value: "CLIENT BRANCH" },
    //       { value: "Address" },
    //       { value: "STATE NAME" },
    //       { value: "REGION NAME" },
    //       { value: "ZONE NAME" },
    //       { value: "LATITUDE" },
    //       { value: "LONGITUDE" },
    //       // { value: "H1" },
    //     ],
    //     [
    //       { value: "UDS" },
    //       { value: "0978" },
    //       { value: "TAMIL NADE" },
    //       { value: "CHENNAI" },
    //       { value: "TAMBARAN" },
    //       { value: "12.687" },
    //       { value: "19.657" },
    //       // { value: "H2" },
    //     ],
    //     [
    //       { value: "CODOID" },
    //       { value: "0978" },
    //       { value: "TAMIL NADE" },
    //       { value: "CHENNAI" },
    //       { value: "TAMBARAN" },
    //       { value: "12.687" },
    //       { value: "19.657" },
    //       // { value: "H3" },
    //     ],
    //     [
    //       { value: "UDS" },
    //       { value: "0978" },
    //       { value: "TAMIL NADE" },
    //       { value: "CHENNAI" },
    //       { value: "TAMBARAN" },
    //       { value: "12.687" },
    //       { value: "19.657" },
    //       // { value: "H4" },
    //     ],
    //     [
    //       { value: "UDS" },
    //       { value: "0978" },
    //       { value: "TAMIL NADE" },
    //       { value: "CHENNAI" },
    //       { value: "TAMBARAN" },
    //       { value: "12.687" },
    //       { value: "19.657" },
    //       // { value: "H5" },
    //     ],
    //     [
    //       { value: "UDS" },
    //       { value: "0978" },
    //       { value: "TAMIL NADE" },
    //       { value: "CHENNAI" },
    //       { value: "TAMBARAN" },
    //       { value: "12.687" },
    //       { value: "19.657" },
    //       // { value: "H6" },
    //     ],
    //   ]);
    // }
  }, [FileType]);

  // Client sample sheet: columns of the chosen organisation come from the backend
  const handleClientSampleDownload = async () => {
    if (!organization?.value) {
      setOrganizationErr("*organisation is required");
      return;
    }
    setSampleLoading(true);
    try {
      const response = await axios({
        method: "get",
        url: ClientBulkUploadSampleSheetApi,
        params: { organization_id: organization.value },
        headers: { Authorization: "Bearer " + userSessionData?.session?.token },
      });
      const columns = response?.data?.data;
      if (!Array.isArray(columns) || columns.length === 0) {
        toast.error("No sample columns found for this organisation");
        return;
      }
      // `details` is the one sample row, same order as the columns
      const sampleRow = response?.data?.details;
      const ws = XLSX.utils.aoa_to_sheet(Array.isArray(sampleRow) ? [columns, sampleRow] : [columns]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, `${FileType}_${organization.label}.xlsx`);
    } catch (error) {
      toast.error(
        error?.response?.data?.status?.message ||
          error?.response?.data?.message ||
          "Failed to load sample sheet columns"
      );
    } finally {
      setSampleLoading(false);
    }
  };

  const handleDownload = () => {
    if (FileType === "client_parent") {
      handleClientSampleDownload();
      return;
    }
    const aoaData = datas.map((row) => row.map((cell) => cell.value));
    if (datas.length === 0) {
      console.error("No data to download");
      return;
    }

    // Convert data to array of arrays (AoA) format

    // Check if aoaData is correctly created
    if (aoaData.length === 0 || aoaData[0].length === 0) {
      console.error("AoA Data is empty or incorrectly formatted:", aoaData);
      return;
    }

    // Create a new workbook and a worksheet
    const ws = XLSX.utils.aoa_to_sheet(aoaData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Write the workbook to a buffer
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    console.log("Excel Buffer:", new Uint8Array(excelBuffer)); // Debugging line

    // Create a Blob from the buffer and save it as an Excel file
    try {
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, `${FileType}.xlsx`);
      console.log("File saved successfully");
    } catch (error) {
      console.error("Error creating Blob or saving file:", error);
    }
  };

  console.log(file, "file");

  const HandleUpload = () => {
    var a = 0;
    if (FileType == "") {
      a = 1;
      setFileErr("*file name is required");
    }
    if (file == "" || file == undefined) {
      a = 1;
      setFileEp("*file is required");
    }
    if (a == 0 && ErrorKey == 0) {
      formdatas.append("file", file);
      formdatas.append("file_type", FileType);

      // console.log(FileType, "FileType", file);
      const payload = {
        formdatas: formdatas,
      };
      dispatch(setTheSHeetuploaAction(payload));
      // setFileType("");
      // setFile("");
    }
  };

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch"
          style={{
            padding: "14px 28px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px !important",
          }}
        >
          <div className="col-sm-7 auto" style={{ display: "flex", alignItems: "center" }}>
            <h3 className="user-name mb-0">Sheet Upload </h3>
          </div>
          <div className="Add-User col-sm-5" style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "12px" }}>
            <div style={{ width: "180px", marginBottom: "10px" }}>
              <Select
                options={reportTypeOptions}
                value={reportTypeFilter}
                onChange={(option) => {
                  setReportTypeFilter(option);
                  setdtPageindex(1);
                  setCurrentPage(1);
                }}
                isSearchable={false}
              />
            </div>
            <button
              onClick={() => setUploadPopup(true)}
              className="ButtonCSS"
              style={{ marginBottom: "10px" }}
            >
              Bulk Upload
            </button>
          </div>
        </div>
        <div
          className="sheet-upload-table"
          style={{ padding: " 0px 40px", marginTop: "-13px", marginBottom: "20px" }}
        >
          {/* fixed column widths so the table scrolls horizontally instead of squeezing (same approach as Denave self onboarding) */}
          <style>{`
            .sheet-upload-table .table-responsive { overflow-x: auto; container-type: inline-size; }
            .sheet-upload-table .INNERTABLE { width: max-content; min-width: 100%; }
            .sheet-upload-table .Dusbinbacktabls { position: sticky; left: 0; width: 100cqw; }
            .sheet-upload-table .table-responsive > .row { position: sticky; left: 0; width: 100cqw !important; }
            .sheet-upload-table .TableDesgin { min-width: 1300px; }
            .sheet-upload-table .TableDesgin th,
            .sheet-upload-table .TableDesgin td {
              width: auto !important;
              white-space: nowrap;
              vertical-align: middle;
              padding: 12px 14px !important;
            }
            .sheet-upload-table .TableDesgin td p { margin: 0; }
          `}</style>
          <ReactTable
            data={sheetBulkUploaddata ? sheetBulkUploaddata : []}
            columns={historyColumns}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            dtpagesize={20}
            dtpageindex={dtpageindex}
            pageindex={(arg) => setdtPageindex(arg)}
            totalItems={totalCount}
            datacount={totalCount}
            MakeCreate={false}
            onPrevious={(previous) => previous != 0 && setdtPageindex(previous)}
            onNextpage={(next) => setdtPageindex(next + 1)}
            GotoEnteredPage={(gotopage) => setdtPageindex(gotopage)}
            placeHold={"All"}
            setsno={setsno}
            sno={sno}
            id={"spe"}
            ApproveRequestFilter={true}
          />
        </div>
        {uploadPopup && (
          <SheetUploadPopup setPopup={setUploadPopup} reportType={reportTypeFilter.value} />
        )}
      </div>
    </>
  );

// ---- Old Sheet Upload screen (commented, not removed) ----
//   return (
//     <>
//       <div className={stateDisplay ? "outterContent" : "inner-Content"}>
//         <div
//           className="Header-Details ClientBranch row"
//           style={{ padding: "14px 28px" }}
//         >
//           <div
//             // className="InnerUsers col-md-6"
//             class="col-sm-7 auto"
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "flex-start",
//               justifyContent: "flex-start",
//             }}
//           >
//             <h3 class="user-name mb-0">Sheet Upload </h3>
// 
// 
//           </div>
//         </div>
// 
//         <div
//           className="UploadSHEET"
//           style={{
//             background: "#fff",
//             borderRadius: "12px",
//             boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
//             margin: "10px 28px 28px",
//             padding: "12px 0 32px",
//           }}
//         >
//           <div
//             className="row Filters"
//             style={{ marginRight: "0px", padding: " 0px 45px" }}
//           >
//             <div className="col-6 mt-3" style={{zIndex:"99"}}>
//               <label for="validationCustom01" class="form-label">
//                 Upload Options
//                 <span style={{ color: "red" }}>*</span>
//               </label>
//               <Select
//                 className="Selects stateNames"
//                 styles={{ position: "relative", top: "60px" }}
//                 onChange={(e) => {
//                   handleSelectChange(e);
//                   setFileErr("");
//                 }}
//                 options={options}
//                 labelledBy="Select"
//               />
//               <p className="Error">{fileErr}</p>
//             </div>
//             {FileType === "client_parent" && (
//               <div className="col-6 mt-3" style={{ zIndex: "98" }}>
//                 <label for="validationCustom02" class="form-label">
//                   Organisation (for sample sheet)
//                   <span style={{ color: "red" }}>*</span>
//                 </label>
//                 <Select
//                   className="Selects stateNames"
//                   placeholder="Select organisation"
//                   value={organization}
//                   onChange={(e) => {
//                     setOrganization(e);
//                     setOrganizationErr("");
//                   }}
//                   options={organizationOptions}
//                   labelledBy="Select"
//                 />
//                 <p className="Error">{organizationErr}</p>
//               </div>
//             )}
//           </div>
//           <div className="Uploadningfield" style={{ marginTop: "50px" }}>
//             <div
//               class="row"
//               style={{
//                 marginRight: "0px",
//                 padding: " 0px 45px",
//                 display: "flex",
//                 justifyContent: "flex-start",
//               }}
//             >
//               <div className="col-6">
//                 <form class="form">
//                   <div
//                     class="file-upload-wrapper"
//                     data-text="Select your file!"
//                   >
//                     <input
//                       name="file-upload-field"
//                       type="file"
//                       class="file-upload-field"
//                       onChange={(e) => {
//                         // HandleChanegsFile(e);
//                         // setFileEp("");
// 
//                         const file = e.target.files[0];
//                         const fileName = file.name.toLowerCase();
//                         if (
//                           fileName.endsWith(".xls") ||
//                           fileName.endsWith(".xlsx")
//                         ) {
//                           // Handle the file upload
//                           HandleChanegsFile(e);
//                           setFileEp("");
//                           setErroKey(0);
//                         } else {
//                           // Display an error message or handle the case where the file is not an Excel sheet
// 
//                           toast.error(
//                             ` ${"Please select an Excel file (.xls or .xlsx)"} `,
//                             {
//                               position: toast.POSITION.TOP_RIGHT,
//                             }
//                           );
//                           setFile();
//                           // You can also clear the input field if needed
//                           e.target.value = "";
//                           // Optionally, perform additional actions such as resetting state or displaying an error message
//                           setFileEp(
//                             "*Please select an Excel file (.xls or .xlsx)"
//                           );
//                           setErroKey(1);
//                         }
//                       }}
//                     />
//                   </div>
//                 </form>
//                 <p className="Error">{fileemp}</p>
// 
//                 <div
//                   className="row"
//                   style={{
//                     marginRight: "0px",
//                     padding: " 0px 45px",
//                     display: "flex",
//                     justifyContent: "flex-end",
//                   }}
//                 >
//                   <div
//                     className="col-12 mt-5"
//                     style={{
//                       display: "flex",
//                       gap: "20px",
//                       justifyContent: "flex-end",
//                     }}
//                   >
//                     <button
//                       class="btn  SaveBtn"
//                       style={{ background: "#F16039", color: "#ffff" }}
//                       type="submit"
//                       onClick={(e) => HandleUpload()}
//                     >
//                       Submit
//                     </button>
//                     {FileType != "" && FileType != "client_branch" ? (
//                       <button
//                         class="btn  SaveBtn"
//                         style={{ background: "#ef4d39", color: "#ffff" }}
//                         type="submit"
//                         disabled={sampleLoading}
//                         onClick={(e) => handleDownload()}
//                       >
//                         Preview{" "}
//                       </button>
//                     ) : null}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           {/* 
//           <div
//             className="row"
//             style={{ marginLeft: "0px", marginRight: "0px" }}
//           >
//             <div className="col-12 mt-5">
//               <MySpreadsheet FileType={FileType} />
//             </div>
//           </div> */}
//         </div>
//       </div>
//     </>
//   );
};

export default SheetUpload;
